module.exports = require("remark-autolink-headings");


//////////////////
// WEBPACK FOOTER
// external "remark-autolink-headings"
// module id = 52
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13